import tinycolor from "tinycolor2";

export interface ColorShades {
  [shade: string]: string;
}

export const generateColorShades = (hexColor: string): ColorShades => {
  const shades: ColorShades = {};
  const shadeLevels = {
    50: 95,
    100: 90,
    200: 75,
    300: 60,
    400: 45,
    500: 0,
    600: -15,
    700: -30,
    800: -45,
    900: -60,
  };

  Object.entries(shadeLevels).forEach(([shade, percentage]) => {
    let color;
    if (percentage >= 0) {
      color = tinycolor(hexColor).lighten(percentage).toRgbString();
    } else {
      color = tinycolor(hexColor).darken(-percentage).toRgbString();
    }
    // @ts-ignore
    const rgb = color.match(/\d+/g).slice(0, 3).join(" ");
    shades[shade] = rgb; // e.g., "255 115 179"
  });

  return shades;
}

